import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { CropAidEffects } from './store/crop-aid.effects';
import { cropAidReducer } from './store/crop-aid.reducer';

@NgModule({
  providers: [provideState('crop-aid', cropAidReducer), provideEffects([CropAidEffects])],
})
export class CropAidModule {}
